import { denormalize } from 'denormalizr';

import { apiAction, apiFetch } from 'utils';
import DuckEntity from './DuckEntity';

class SingletonDuckEntity extends DuckEntity {
  initialState = {
    object: {},
    ready: false,
    pending: true,
    error: false,
    fetching: false,
    errorMessage: undefined
  };

  reducer = (state = this.initialState, action) => {
    const { payload = {} } = action;
    const { result = {} } = payload;

    switch (action.type) {
      case this.types.LOAD_BEGIN:
        return {
          ...state,
          ready: false,
          pending: true,
          error: false,
          errorMessage: undefined,
          fetching: true
        };

      case this.types.LOAD_SUCCESS:
        return {
          ...state,
          object: result[this.config.jsonRoot],
          ready: true,
          pending: false,
          error: false,
          errorMessage: undefined,
          fetching: false
        };

      case this.types.LOAD_ERROR:
        return {
          ...state,
          object: result[this.config.jsonRoot],
          ready: false,
          pending: false,
          error: true,
          errorMessage: payload.message || payload.error,
          fetching: false
        };

      case this.types.SAVE_ERROR:
        return {
          ...state,
          errors: payload.errors,
          error: true,
          fetching: false
        };

      case this.types.SAVE_SUCCESS:
        return {
          ...state,
          object: result[this.config.jsonRoot],
          ready: true,
          pending: false,
          fetching: false
        };

      default:
        return state;
    }
  };

  load = () => apiAction(
    this.types.LOAD_BEGIN, this.types.LOAD_SUCCESS, this.types.LOAD_ERROR,
    (state) => apiFetch.get(state, this.config.apiPath),
    { entityName: this.name },
    { [this.config.jsonRoot]: this.config.schema }
  );

  save = (object) => apiAction(
    this.types.SAVE_BEGIN, this.types.SAVE_SUCCESS, this.types.SAVE_ERROR,
    (state) => apiFetch.put(state, this.config.apiPath, { [this.config.jsonRoot]: object }),
    { entityName: this.name, create: false, update: true },
    { [this.config.jsonRoot]: this.config.schema }
  );

  update = (object, params = {}, stateKey = '_all') =>
    apiAction(
     this.types.SAVE_BEGIN, this.types.SAVE_SUCCESS, this.types.SAVE_ERROR,
      (state) => apiFetch.put(state, this.config.apiPath, { [this.config.jsonRoot]: object, ...params }, this.config.updateOptions),
      {
        entityName: this.name,
        create: false,
        update: true,
        stateKey
      },
      { [this.config.jsonRoot]: this.config.schema }
    );

  all = (state) => {
    const loadState = state[this.name] || this.initialState;
    const results = denormalize(loadState.object, state.entities, this.config.schema);
    const meta = {
      ready: loadState.ready,
      pending: loadState.pending,
      error: loadState.error,
      fetching: loadState.fetching,
      errorMessage: loadState.errorMessage
    };

    return { value: results, meta };
  };

  actions = {
    ...(this.actions),
    load: this.load,
    save: this.save,
    update: this.update
  };
}

export default SingletonDuckEntity;
